export enum LoaderWidgetType {
  FULL_FOUR_COLUMNS,
  FULL_TWO_COLUMNS,
  TWO_THIRDS,
  ONE_THIRD,
}

export const LOADER_WIDGETS = [
  {
    id: '1',
    type: LoaderWidgetType.FULL_FOUR_COLUMNS,
    width: 12,
    height: 3,
  },
  {
    id: '2',
    type: LoaderWidgetType.FULL_TWO_COLUMNS,
    width: 12,
    height: 2,
  },
  {
    id: '3',
    type: LoaderWidgetType.TWO_THIRDS,
    width: 8,
    height: 7,
  },
  {
    id: '4',
    type: LoaderWidgetType.ONE_THIRD,
    width: 4,
    height: 7,
  },
  {
    id: '5',
    type: LoaderWidgetType.TWO_THIRDS,
    width: 4,
    height: 7,
  },
  {
    id: '6',
    type: LoaderWidgetType.ONE_THIRD,
    width: 8,
    height: 7,
  },
  {
    id: '7',
    type: LoaderWidgetType.TWO_THIRDS,
    width: 8,
    height: 7,
  },
  {
    id: '8',
    type: LoaderWidgetType.ONE_THIRD,
    width: 4,
    height: 7,
  },
];
